export const imagenNormalize = (source) => {
    return {
        idImagen: source.idImagen ?? source.IdImagen ?? 0,
        nombre: source.nombre ?? source.Nombre ?? '',
        descripcion: source.descripcion ?? source.Descripcion ?? '',
        idTipoImagen: source.idTipoImagen ?? source.IdTipoImagen ?? 0,
        nombreTipoImagen: source.nombreTipoImagen ?? source.NombreTipoImagen ?? '',
        imagenUrl: source.imagenUrl ?? source.ImagenUrl ?? '',
        activo: source.activo ?? source.Activo ?? false,
        nombreEmpresa: source.nombreEmpresa ?? source.NombreEmpresa ?? null,
        idEmpresa: source.idEmpresa ?? source.IdEmpresa ?? null
    };
};

export const tipoImagenNormalize = (source) => {
    return {
        idTipoImagen: source.idTipoImagen ?? source.IdTipoImagen ?? 0,
        nombre: source.nombre ?? source.Nombre ?? '',
        activo: source.activo ?? source.Activo ?? false
    };
};
